module.exports = __webpack_public_path__ + "media/photo/technology_features-718870da.png";